import React from 'react';
import { DocumentStatus } from 'types/documentsService';
import {
  ApprovedIconStyled,
  ErrorOutlineStyled,
  InfoButtonStyled,
  RadioButtonUncheckedStyled,
  RejectedIconStyled,
  SignedIconStyled,
  UploadedIconStyled,
} from './styles';
import {
  APPROVED_ICON_TEST_ID,
  BYPASSED_ICON_TEST_ID,
  INACTIVE_ICON_TEST_ID,
  NOT_UPLOADED_ICON_TEST_ID,
  REJECTED_ICON_TEST_ID,
  SIGNATURE_PENDING_ICON_TEST_ID,
  SIGNATURE_REQUEST_FAILED_ICON_TEST_ID,
  SIGNED_ICON_TEST_ID,
  UPLOADED_ICON_TEST_ID,
} from '../constants';

interface Props {
  status: DocumentStatus;
}

const DocumentStatusIcon: React.FC<Props> = ({ status }) => {
  switch (status) {
    case DocumentStatus.BYPASSED:
      return <RadioButtonUncheckedStyled $color="grey" data-test-id={BYPASSED_ICON_TEST_ID} />;
    case DocumentStatus.INACTIVE:
      return <InfoButtonStyled data-test-id={INACTIVE_ICON_TEST_ID} />;
    case DocumentStatus.NOT_UPLOADED:
      return <RadioButtonUncheckedStyled $color="red" data-test-id={NOT_UPLOADED_ICON_TEST_ID} />;
    case DocumentStatus.UPLOADED:
      return <UploadedIconStyled data-test-id={UPLOADED_ICON_TEST_ID} />;
    case DocumentStatus.APPROVED:
      return <ApprovedIconStyled data-test-id={APPROVED_ICON_TEST_ID} />;
    case DocumentStatus.REJECTED:
      return <RejectedIconStyled viewBox="3 3 25 25" data-test-id={REJECTED_ICON_TEST_ID} />;
    case DocumentStatus.SIGNATURE_PENDING:
      return <RadioButtonUncheckedStyled $color="orange" data-test-id={SIGNATURE_PENDING_ICON_TEST_ID} />;
    case DocumentStatus.SIGNATURE_REQUEST_FAILED:
      return <ErrorOutlineStyled data-test-id={SIGNATURE_REQUEST_FAILED_ICON_TEST_ID} />;
    case DocumentStatus.SIGNED:
      return <SignedIconStyled data-test-id={SIGNED_ICON_TEST_ID} />;
    default:
      return null;
  }
};

export default DocumentStatusIcon;
